module.exports = __webpack_public_path__ + "img/badge-sync.c92623f3.svg";